import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Logins } from '../login/login-access/login';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OauthService {
  private _baseurl = environment.api_url;
  private _baseinvestmfonlineurl = environment.invest_mfonline_api_url;
  currentTimestamp = new Date().getTime();
  constructor(private http: HttpClient, private _router: Router) { }
  loginUser(data: Logins) {
    return this.http.post<Logins>(this._baseurl + '/oauth', data);
  }

  getToken() {
    return sessionStorage.getItem('accessToken');
  }
  leadCountDetail(url, pldata, hldata, cldata, ccdata) {
    return forkJoin(this.http.post<any>(this._baseurl + url, pldata),
      this.http.post<any>(this._baseurl + url, hldata),
      this.http.post<any>(this._baseurl + url, cldata),
      this.http.post<any>(this._baseurl + url, ccdata));
  }
  httpGet(url) {
    return this.http.get<any>(this._baseurl + url);
  }

  httpPost(url, postData) {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = {
      headers: httpHeaders
    };
    return this.http.post<any>(this._baseurl + url, JSON.stringify(postData), options);
  }
        
    httpPut(url, postData) {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = {
      headers: httpHeaders
    };
    return this.http.put<any>(this._baseurl + url, JSON.stringify(postData), options);
  }

  httpGetInvestMfonline(url) {
    return this.http.get<any>(this._baseinvestmfonlineurl + url);
  }
  logoutUser() {
    this.clearSession();
    this._router.navigate(['/login']);
  }
  loggedIn() {
    const expireTimestamp = parseInt(sessionStorage.getItem('expireTimestamp'), 10);
    if (this.currentTimestamp >= expireTimestamp) {
      this.clearSession();
      return false;
    }
    return sessionStorage.getItem('accessToken');
  }

  clearSession() {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('expiresIn');
    sessionStorage.removeItem('expireTimestamp');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('userRole');
  }
  
  checkDocExist(subFolder: string): Observable<string> {     
      return this.http.get(`${subFolder}`, { observe: 'response', responseType: 'blob' })
        .pipe(
          map(response => {
            return 'file';
          }),
          catchError(error => {
            return "NA";
          })
        );
  }  

}
